import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiPageHeadingDTO,
  PageHeadingDTO,
} from "@lib/strapi/dtos/components/shared/pageHeading.dto";
import { getImageProps, ImageProps } from "@lib/image";
import { LinkService } from "@lib/strapi/services/components/shared/link.service";

export class PageHeadingService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiPageHeadingDTO,
  ): Promise<PageHeadingDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new PageHeadingDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.title = strapiData.title;
    dto.subtitle = strapiData.subtitle;
    dto.className = strapiData.className;
    dto.image = getImageProps(strapiData.image);
    dto.links = await Promise.all(
      (strapiData.links ?? []).map(
        async (item) => await LinkService.fromStrapi(locale, item),
      ),
    );
    return dto;
  }
}
